import { capitalize, FCX, Tooltip } from '@datassential/platform-ui-lib';
import BarChart, { BarChartItem, BarRenderProps } from '@components/BarChart/BarChart';
import { LandscapeCuisine } from '@apiHooks/useLandscapeRestaurantData';
import { CUISINES_TITLE } from './HomeLandscape.constants';

interface LandscapeCuisinesChartProps {
    cuisines: LandscapeCuisine[];
}

const TOOLTIP_ID = 'landscape-cuisine-tooltip';

const LandscapeCuisinesChart: FCX<LandscapeCuisinesChartProps> = ({ cuisines }) => {
    if (cuisines.length === 0) {
        return (
            <div className="LandscapeCuisinesChart" data-testid="blockLandscapeCuisinesChart">
                <h3 className="LandscapeCuisinesChart__title">{CUISINES_TITLE}</h3>
                <p className="LandscapeCuisinesChart__empty">No cuisine data available.</p>
            </div>
        );
    }

    const chartData: BarChartItem[] = cuisines.map((c, index) => ({
        id: index,
        name: c.name ? capitalize(c.name) : '',
        value: c.chainCount ?? 0,
    }));

    const renderBar = (item: BarChartItem, _index: number, barProps: BarRenderProps) => (
        <div
            key={`cuisine-bar-${item.name}`}
            className={barProps.className}
            style={barProps.style}
            data-tooltip-id={TOOLTIP_ID}
            data-tooltip-content={`${item.name}: ${item.value.toLocaleString()} chains`}
        />
    );

    return (
        <div className="LandscapeCuisinesChart" data-testid="blockLandscapeCuisinesChart">
            <h3 className="LandscapeCuisinesChart__title">{CUISINES_TITLE}</h3>
            <BarChart data={chartData} renderBar={renderBar} />
            <Tooltip id={TOOLTIP_ID} place="top" style={{ zIndex: 1001 }} />
        </div>
    );
};

export default LandscapeCuisinesChart;
